/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Common model actions
  Date: April 2020
**/

import { action } from 'easy-peasy';
// import * as commonService from '../../services/common';

const commonModel = {
  drawerState: [],
  setDrawer: action((state, payload) => {
    state.drawerState = payload;
  }),
  submitSnackbar: {
    status: false,
    messages: '',
    error: false,
    timeout: 2000,
  },
  setSubmitSnackbar: action((state, payload) => {
    if (!payload.timeout) {
      payload.timeout = 2000;
    }
    state.submitSnackbar = payload;
  }),
};

export default commonModel;
